import { cn, Stack } from 'component-library';
import { FC, HTMLAttributes } from 'react';

export const DataGroup: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...delegated }) => (
  <div className={cn('p-6', className)} {...delegated} />
);

export const DataStack = Stack;

export const DataStackLabel: FC<HTMLAttributes<HTMLSpanElement>> = ({ className, ...delegated }) => (
  <span className={cn('typography-overline mb-2', className)} {...delegated} />
);
export const DataStackContent: FC<HTMLAttributes<HTMLSpanElement>> = ({ className, ...delegated }) => (
  <span className={cn('typography-h3', className)} {...delegated} />
);
